module.exports = __webpack_public_path__ + "static/media/img_logo.b5f41000.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/img_logo.webp
// module id = 164
// module chunks = 1